import React from 'react'
import { Label, Input, FormGroup } from 'reactstrap'

const DropdownInput = ({
  label,
  name,
  value,
  onChange,
  options
}) => {
  return (
    <FormGroup>
      <Label for={name}>{label}</Label>
      <Input
        type="select"
        name={name}
        id={name}
        value={value}
        onChange={onChange}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Input>
    </FormGroup>
  )
}

export default DropdownInput
